<template>
  <div class="w-full bg-white pb-16 tab-content">
    <div class="header-content px-4 py-8 mb-4 border-b flex items-center justify-between">
      <h2>{{ $t('message.selfService.taskManager.identifies') }}</h2>
      <transition name="fade" mode="out-in">
        <div class="flex justify-end items-center" v-if="shownSave">
          <zt-button color="dark-300" @click="cancel" class="mr-4" data-vs-button="cancel-identify-edit">
            {{ $t('message.selfService.linkCancel') }}
          </zt-button>
          <zt-button @click="saveIdentifyInfo" :loader="isLoading" data-vs-button="confirm-identify-edit">
            {{ $t('message.selfService.linkSaveInformation') }}
          </zt-button>
        </div>
      </transition>
    </div>
    <div class="px-4 pb-1" :key="reRenderKey">
      <vue-element-loading
          :active="isLoading"
          spinner="mini-spinner"
          color="#004250"
          style="height: 100%; width: 100%; z-index: 100"
      />
      <div v-if="shownAlert" class="mb-12">
        <zt-alert :color="statusAlert" close-icon filled @afterClosed="closeAlert" class="message px-3 py-3">
          <div slot="custom-content">
            <div class="flex justify-start items-center">
              <zt-icon v-if="iconName" :name="iconName" class="icon mr-3"></zt-icon>
              <p class="text-base">{{ messageAlert }}</p>
            </div>
          </div>
        </zt-alert>
      </div>
      <div class="flex">
        <div class="w-1/2 mr-4 custom-input mt-10 relative">
          <zt-input
            class="w-full"
            v-model="params.nick_name"
            v-validate="{ min: 3, max:150 , regex: /^[A-zÀ-ú-'-\s]*$/ }"
            name="nick_name"
            :color="errors.has('nick_name') ? 'danger' : 'primary'"
            disabled
            :label="$t('message.selfService.taskManager.field.myNickName')"
            data-vs-input="nick-name"
          />
          <div class="text-zt-danger" v-if="errors.has('nick_name')">
            <span>
              {{ errors.first('nick_name') }}
            </span>
          </div>
        </div>
        <div class="w-1/2 ml-4 mt-10 custom-input relative">
          <zt-input
            class="w-full"
            v-model="genre"
            disabled
            name="genre"
            :label="$t('message.selfService.taskManager.field.myGenre')"
            data-vs-select="genre"
          />
        </div>
      </div>
      <div class="flex">
        <div class="w-full mt-10 custom-input relative">
          <zt-button
            data-vs-button="download-picture"
            :disabled="!loadPicture" :loader="isDownloadLoading" @click="download"
          >
            {{ $t('message.selfService.linkDownloadPicture') }}
          </zt-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isEqual } from 'lodash'
import VueElementLoading from 'vue-element-loading'
import Employee from '@/apiClient/Employee'
import parseNull from '@/utils/parseNull'
import { find } from 'lodash'
const icons = {
  'danger': 'exclamation-circle-solid',
  'info': 'info-circle-solid'
}
const bool = [true, 't', 1]
export default {
  name: 'UserIdentifyInfo',
  components: {
    VueElementLoading
  },
  props: {
    updateFn: {
      type: Function,
      default: () => {}
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dataIdentify: {},
      items: [
        {
          label: this.$t('message.employeePanel.identifyGenre.man'),
          value: 'M'
        },
        {
          label: this.$t('message.employeePanel.identifyGenre.woman'),
          value: 'F'
        },
        {
          label: this.$t('message.employeePanel.identifyGenre.noBinary'),
          value: 'N'
        },
        {
          label: this.$t('message.employeePanel.identifyGenre.other'),
          value: 'U'
        }
      ],
      isLoading: false,
      isDownloadLoading: false,
      loadPicture: false,
      params: {
        nick_name: '',
        genre: '',
        file: '',
      },
      shownAlert: false,
      shownSave: false,
      statusAlert: 'info',
      messageAlert: '',
      cache: {},
      reRenderKey: 0,
      genre: ''
    }
  },
  watch: {
    params: {
      handler(newParams) {
        this.shownSave = !isEqual(this.cache, newParams)
        this.setGenre(newParams.genre)
      },
      deep: true
    }
  },
  computed: {
    iconName() {
      return icons[this.statusAlert]
    }
  },
  created() {
    this.employee = new Employee()
  },
  mounted() {
    this.getEmployeeIdentifyInfo()
  },
  methods: {
    closeAlert() {
      this.shownAlert = false
    },
    cancel() {
      this.infoUpdate()
      this.errors.clear()
      this.shownAlert = false
      this.reRenderKey += 1
    },
    async download() {
      this.isDownloadLoading = true
      const userId = this.$route.params.id
      try {
        const { headers, data: file } = await this.employee.getUserPerceptionAvatar(userId)
        if (file) {
          const imageType = headers['content-type']
          const blob = new Blob([file], { type: imageType })
          const imageURL = URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = imageURL
          link.download = userId + '.' + imageType.split('/').pop()
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          this.isDownloadLoading = false
        }
      } catch (e) {
        this.isDownloadLoading = false
      }
    },
    infoUpdate() {
      this.params = { ...this.dataIdentify }
      this.cache = { ...this.dataIdentify }
      this.loadPicture = bool.includes(this.dataIdentify.url_picture)
    },
    saveIdentifyInfo() {
      this.params ? this.editIdentify() : this.saveIdentify()
    },
    async editIdentify() {
      this.isLoading = true
      const idEmployee = this.$route.params.id
      const payload = {

      }
      try {
        await this.employee.updateIdentifyInfo(idEmployee, payload)
        this.shownSave = false
        this.dataIdentify = payload
        this.durationAlert = 5
        this.messageAlert = this.$t(`message.selfService.statusOk`)
        this.statusAlert = 'info'
        this.shownAlert = true
        this.isLoading = false
      } catch (error) {
        if (error.response.data) {
          this.messageAlert = this.$t(
              `message.selfService.errors.${error.response.data.codes[0].code}`
          )
          this.statusAlert = 'danger'
          this.shownAlert = true
        }
        this.isLoading = false
      }
    },
    async saveIdentify() {
      this.isLoading = true
      const idEmployee = this.$route.params.id
      const payload = {

      }
      try {
        await this.employee.createIdentifyInfo(idEmployee, payload)
        this.durationAlert = 5
        this.messageAlert = this.$t(`message.selfService.statusOk`)
        this.statusAlert = 'info'
        this.shownAlert = true
        this.isLoading = false
      } catch (error) {
        if (error.response.data) {
          this.messageAlert = this.$t(
              `message.selfService.errors.${error.response.data.codes[0].code}`
          )
          this.statusAlert = 'danger'
          this.shownAlert = true
        }
        this.isLoading = false
      }
    },
    async getEmployeeIdentifyInfo() {
      const idEmployee = this.$route.params.id
      this.isLoading = true
      try {
        const {
          data: { data }
        } = await this.employee.getIdentifyInfo(idEmployee)
        this.dataIdentify = parseNull({ ...data })
        await this.infoUpdate()
        this.reRenderKey += 1
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
      }
    },
    setGenre(genre) {
      if(this.params) {
        this.genre = find(this.items, { value: genre }).label
      }
    }
  }
}
</script>

<style scoped lang="scss">
.tab-content {
  box-shadow: 0 2px 4px rgba(0, 0, 0, .25);
  border-radius: 4px;
}
.header-content {
  h2 {
    font-weight: 500;
    font-size: 18px;
    line-height: 23px;
    color: #4F41A3;
  }
}
::v-deep .zt-input-disabled .zt-input-slot .zt-label[data-v-aea3bcaa] {
  color: #969696;
}
</style>